import { render, staticRenderFns } from "./SettingsFollowDepartmentMemberListItem.vue?vue&type=template&id=1c78add0&scoped=true&"
import script from "./SettingsFollowDepartmentMemberListItem.vue?vue&type=script&lang=js&"
export * from "./SettingsFollowDepartmentMemberListItem.vue?vue&type=script&lang=js&"
import style0 from "./SettingsFollowDepartmentMemberListItem.vue?vue&type=style&index=0&id=1c78add0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c78add0",
  null
  
)

export default component.exports